import { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../lib/firebase";

export const useUserRole = (appToken: string) => {
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(() => {
    const userId = localStorage.getItem(appToken);

    const fetchUserRole = async () => {
      if (userId) {
        try {
          const userQuery = query(
            collection(db, "users"),
            where("uid", "==", userId)
          );
          const querySnapshot = await getDocs(userQuery);

          if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0].data();
            setUserRole(userDoc.role);
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      }
    };

    fetchUserRole();
  }, [appToken]);

  return userRole;
};

export const useAutherRole = (appToken: string | null) => {
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(() => {
    const userId = appToken;

    const fetchUserRole = async () => {
      if (userId) {
        try {
          const userQuery = query(
            collection(db, "users"),
            where("uid", "==", userId)
          );
          const querySnapshot = await getDocs(userQuery);

          if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0].data();
            setUserRole(userDoc.role);
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      }
    };

    fetchUserRole();
  }, [appToken]);

  return userRole;
};

export const useUserActive = (appToken: string | null) => {
  const [userRole, setUserRole] = useState<boolean>(false);

  useEffect(() => {
    const userId = localStorage.getItem(appToken!);

    const fetchUserRole = async () => {
      if (userId) {
        try {
          const userQuery = query(
            collection(db, "users"),
            where("uid", "==", userId)
          );
          const querySnapshot = await getDocs(userQuery);

          if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0].data();
            if (userDoc.active && userDoc.isbusiness) {
              setUserRole(true);
            }
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      }
    };

    fetchUserRole();
  }, [appToken]);

  return userRole;
};
